export { sleep } from './async/sleep';
export { auth, shareAuth } from './auth';
export {
  isClient,
  isE2E,
  isMainThread,
  isServer,
  isTest,
  isWorker,
} from './config';
export { getFormattedDate } from './dateTime';
export { isMouseEvent } from './events';
export type { GraphqlMedia } from './files';
export {
  getCopyByFileType,
  getDisplayCategory,
  getFileExtension,
  getGraphqlTypeByFileType,
  getIconByFileType,
  getMimeTypeFromFileExtension,
  getMimeTypeFromFileName,
  getOverrideMimeType,
  isFileExtensionPreviewable,
} from './files';
export {
  formatDateDistanceToNow,
  useDebounce,
  useFormattedRelativeDate,
  useLifecycle,
  useStableCallback,
  useWhyDidYouUpdate,
} from './hooks';
export { useLegacyApiBecauseThereIsNoAlternative } from './hooks/useLegacyApiBecauseThereIsNoAlternative';
export { log } from './log';
export { math } from './math';
export {
  DEFAULT_TIMECODE,
  getOffsetTimecode,
  getOriginalCurrentTime,
  getTimecodeForTime,
  getTimecodeObject,
  isLikelyAVFRAsset,
  timeToStandard,
} from './media';
export { preloadAudio, preloadImage, preloadVideo } from './preload';
export type { StorageType } from './storage';
export { Storage, usePersistedValue } from './storage';
export { getSupportArticleUrl } from './support/getSupportArticleUrl';
export type {
  AddDollarPrefix,
  AddDollarPrefixTo,
  AllOrNone,
  DataAttrs,
  DeepPartial,
  DeepRequire,
  DeepRequireObject,
  DropDollarPrefix,
  EnsureSerializable,
  IDable,
  OneOrOther,
  RemapWithSuffix,
  Serializable,
  SerializableObject,
  UnionToIntersection,
} from './types/utils';

export const stopEventPropagation = (evt) => {
  evt?.stopPropagation();
};

export const consumeEvent = (evt) => {
  evt?.stopPropagation();
  evt?.preventDefault();
};

export const preventDefault = (evt) => {
  evt?.preventDefault();
};

export {
  DEFAULT_INITIAL_PAGE_SIZE,
  DEFAULT_MAX_CHARS,
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  NAME_INPUT_MAX_LENGTH,
  SETTINGS_TABLE_DEFAULT_PAGE_SIZE,
} from './constants';
export { decodeBase64, encodeBase64 } from './encode';
export { imageLoader } from './image';
export { addValueToMutableObject } from './perf/addValueToMutableObject';
export { removeQueryParams, removeURLHash } from './url';

export const DPR = typeof window !== 'undefined' ? window.devicePixelRatio : 3;
